import isEqual from 'react-fast-compare';
import { deepMerge } from '../../utils/deepMerge';
const mapBreakpointsLegacyToNew = (breakpoint, defaultBreakpoints) => {
  const result = deepMerge({}, defaultBreakpoints);
  Object.keys(breakpoint).forEach(legacyKey => {
    result[legacyKey] = {
      ...result[legacyKey],
      ...breakpoint[legacyKey]
    };
  });
  return result;
};
const mapBreakpointsNewToLegacy = (defaultBreakpoints, breakpoints) => {
  const result = deepMerge({}, breakpoints);
  Object.keys(defaultBreakpoints).forEach(legacyKey => {
    result[legacyKey] = {
      ...result[legacyKey],
      ...defaultBreakpoints[legacyKey]
    };
  });
  return result;
};

/**
 * Mapper function that maps customized legacy theme breakpoints to token theme format or maps token theme breakpoints to legacy theme format
 * @param externalLegacyThemeBreakpoints: the customized legacy theme breakpoints
 * @param externalBreakpoints: the token theme breakpoints
 * @param defaultLegacyBreakpoints:  the default legacy theme breakpoints
 * @returns
 */
export const mapBreakpoints = _ref => {
  let {
    externalLegacyThemeBreakpoints,
    externalBreakpoints,
    defaultLegacyBreakpoints
  } = _ref;
  let mappedBreakpoints = externalBreakpoints;
  let mappedLegacyBreakpoints = externalLegacyThemeBreakpoints;
  if (!isEqual(externalLegacyThemeBreakpoints, defaultLegacyBreakpoints)) {
    mappedBreakpoints = mapBreakpointsLegacyToNew(externalLegacyThemeBreakpoints, externalBreakpoints);
  } else {
    mappedLegacyBreakpoints = mapBreakpointsNewToLegacy(externalBreakpoints, externalLegacyThemeBreakpoints);
  }
  return {
    mappedLegacyBreakpoints,
    mappedBreakpoints
  };
};